"use client";

import { useEffect, useState } from "react";
import Link from "@/components/Link";
import { usePathname } from "next/navigation";
import { navLinks, socialLinks } from "@/lib/shared/constants";
import { isNativeCapacitorApp } from "@/lib/client/capacitor";
import SocialIcon from "@/components/layout/SocialIcon";

import styles from "./styles.module.scss";
import { Anchor as MantineAnchor, Box as MantineBox, Text as MantineText } from "@mantine/core";

export const renderIcons = () => (
  <MantineBox className={styles.iconContainer}>
    {socialLinks.map(({ name, url }) => (
      <Link href={url} target="_blank" aria-label={name} className={styles.logo} key={name}>
        <SocialIcon name={name} size={22} />
        <MantineText span className={styles.srOnly}>
          {name}
        </MantineText>
      </Link>
    ))}
  </MantineBox>
);

const Footer = () => {
  const pathname = usePathname();
  const [isNativeApp, setIsNativeApp] = useState(false);

  useEffect(() => {
    setIsNativeApp(isNativeCapacitorApp());
  }, []);

  const shouldHide =
    isNativeApp ||
    pathname === "/search" ||
    pathname?.startsWith("/brands/") ||
    pathname?.startsWith("/search/vendor/") ||
    pathname === "/spotlight";

  if (shouldHide) {
    return null;
  }

  const links = [
    ...navLinks,
    { name: "Brands", url: "/brands" },
    { name: "Vendors", url: "/vendors" },
    { name: "Privacy", url: "/privacy" },
    { name: "Terms", url: "/terms" },
  ];

  return (
    <footer className={styles.footer}>
      <MantineBox className={styles.top}>
        <MantineBox className={styles.links}>
          {links.map(({ name, url }) => (
            <Link prefetch={false} href={url} key={name}>
              {name}
            </Link>
          ))}
        </MantineBox>
        {renderIcons()}
      </MantineBox>
      <MantineBox className={styles.bottom}>
        <MantineBox>
          <MantineText size="xs">
            <MantineAnchor href="mailto:contact@kurb.online">Contact Us</MantineAnchor>
          </MantineText>
          <MantineText size="xs">© {new Date().getFullYear()} KURB</MantineText>
          <MantineText size="xs">CUTTHWICE OÜ · Registry code 17093572</MantineText>
        </MantineBox>
      </MantineBox>
    </footer>
  );
};

export default Footer;
